import VtexVisualizationComponent from '../canvas/VtexVisualizationComponent';
import { filterByMobileState } from '../../utils/functions';
import '../../templates/vtex-apps/mz-styles-all.scss';
import VtexFixedComponent from '../canvas/VtexFixedComponent';

const VisualizationComponentWrapper = ({
	updateHover,
	handleRightClick,
	selectedPage,
	headerLayout,
	footerLayout,
	toggleValue,
}) => {
	return (
		<div className="canvas-iframe canvas" onMouseOver={(e) => updateHover(e)} onContextMenu={handleRightClick}>
			<RenderHeader headerLayout={headerLayout} selectedCanvasResolution={toggleValue} selectedPage={selectedPage} />
			{selectedPage.pageData
				.filter((el) => filterByMobileState(el, toggleValue))
				.map((component, index, arr) => {
					return (
						<VtexVisualizationComponent
							key={`VtexVisualizationComponent-${component.componentId}`}
							{...{
								componentId: component.componentId,
								comp: component,
								componentGroup: component.componentGroup,
							}}
						/>
					);
				})}
			<RenderFooter footerLayout={footerLayout} selectedCanvasResolution={toggleValue} selectedPage={selectedPage} />
		</div>
	);
};

const RenderHeader = ({ headerLayout, selectedCanvasResolution, selectedPage }) => {
	if (selectedPage.pageType.includes('header') || selectedPage?.pageType.includes('menu')) return null;
	if (headerLayout.length) {
		const headerComp = headerLayout.filter(
			(el) => el.componentGroup === (selectedCanvasResolution > 1024 ? 'HeaderDesktop' : 'HeaderMobile'),
		)[0];
		return (
			<VtexFixedComponent
				className="VtexComponent"
				{...{
					index: 0,
					comp: headerComp,
					componentChildren: headerComp.componentChildren,
				}}
			/>
		);
	} else {
		return null;
	}
};

const RenderFooter = ({ footerLayout, selectedCanvasResolution, selectedPage }) => {
	if (selectedPage.pageType.includes('footer') || selectedPage?.pageType.includes('menu')) return null;
	if (footerLayout.length) {
		const footerComp = footerLayout.filter(
			(el) => el.componentGroup === (selectedCanvasResolution > 1024 ? 'FooterDesktop' : 'FooterMobile'),
		)[0];
		return (
			<VtexFixedComponent
				className="VtexComponent"
				{...{
					index: 99,
					componentId: footerComp.componentId,
					key: footerComp.componentId,
					comp: footerComp,
					componentChildren: footerComp.componentChildren,
					zIndex: 999,
					name: footerComp.componentName,
				}}
			/>
		);
	} else {
		return null;
	}
};

export default VisualizationComponentWrapper;
